import { useEffect, useState } from "react";
import { IRating } from "../../services/api/Rating/types";
import { fetchAppointmentRating } from "../../utils/fetchEntities";
import { useAuth } from "../../context/AuthProvider/useAuth";

const useFetchAppointmentRating = (appointmentId: string) => {
  const { user } = useAuth();

  const [rating, setRating] = useState<IRating | null>(null);
  const [loadingRating, setLoadingRating] = useState(false);

  useEffect(() => {
    if (!appointmentId) return;

    setLoadingRating(true);
    fetchAppointmentRating(appointmentId, user.id)
      .then((response) => {
        setRating(response);
      })
      .finally(() => setLoadingRating(false));
  }, [appointmentId]);

  return { rating, loadingRating };
};

export default useFetchAppointmentRating;
